import FormControl from "@mui/material/FormControl";
import MuiRadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Radio from "@mui/material/Radio";
import { Text } from "@imminently/react/ui/core/text";
import { styled } from "@mui/material/styles";


const RadioGroupWrap = styled(FormControl)`
  gap: 0.5rem;

  .MuiFormGroup-root {
    border: 2px solid ${ p => p.theme.palette.primary[500] };
    border-radius: 0.5rem;
  }

  .MuiFormControlLabel-root {
    display: flex;
    flex-direction: row;
    align-items: center;

    .MuiButtonBase-root {
      padding: 0.25rem;
      margin-right: 0.5rem;
    }

    .MuiFormControlLabel-label {
      white-space: pre;
      font-weight: 400;
    }
  }
`;

const HelperText = styled(Text)`
  padding-left: 3rem;
  padding-bottom: 0.5rem;
`;

export type RadioGroupProps = {
  label?: string;
  options: Array<{ label: string; value: string; }>;
  value?: string;
  setValue: (v: string) => unknown;
  helperText?: string;
}
export const RadioGroup: React.FC< RadioGroupProps > = p => {
  const { label, options, value, setValue, helperText } = p;

  return (
    <RadioGroupWrap>
      { label && <Text bold>{ label }</Text> }

      <MuiRadioGroup
        value={value || null}
        onChange={e => setValue(e.target.value)}
      >
        { options.map(o => (
          <FormControlLabel
            key={o.value}
            value={o.value}
            control={<Radio />}
            label={o.label}
          />
        ))}
        { helperText && <HelperText>{ helperText }</HelperText> }
      </MuiRadioGroup>
    </RadioGroupWrap>
  );
};
